export default __webpack_public_path__ + "static/media/milestone 2600.75ba54d6.svg";